import { IresDevice } from "./IresDevice";
import Client from "./Client";

export class ClientFilter {
  clientIds: Set<string> = new Set();
  clients: Client[] = [];
  isSingleClientFilter: boolean;

  get client() {
    return this.isSingleClientFilter ? this.clients[0] : null;
  }

  constructor(...clients: Client[]) {
    if (clients.length == 1) {
      const client = clients[0];
      this.isSingleClientFilter = true;
      this.clients = [client];
      this.clientIds.add(client.id);
    } else {
      clients.forEach((client) => {
        this.clients.push(client);
        this.clientIds.add(client.id);
      });
    }
  }

  doesMatchIresDevice(iresDevice: IresDevice) {
    const clientId = iresDevice.currentAssignment?.clientId;

    return this.doesMatchClientId(clientId);
  }

  /**
   * Uses the id set instead of scanning `clients`: a master client's filter holds
   * every member client, and the device list evaluates this once per device.
   */
  doesMatchClientId(clientId: string | undefined) {
    return !!clientId && this.clientIds.has(clientId);
  }
}
